import React, { createContext, useContext } from 'react';
import { usePermisos } from '../hooks/usePermisos';
import { useAuth } from './AuthContext';

type TipoPermiso = 'materiales' | 'fotos' | 'documentos' | 'tareas';

interface PermisosContextType {
  verificarPermisosObra: (obraId: string) => boolean;
  verificarPermisosTipo: (tipo: TipoPermiso) => boolean;
  puedeEditar: () => boolean;
}

const PermisosContext = createContext<PermisosContextType>({
  verificarPermisosObra: () => false,
  verificarPermisosTipo: () => false,
  puedeEditar: () => false,
});

export const usePermisosContext = () => useContext(PermisosContext);

export const PermisosProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { usuario } = useAuth();
  const { verificarPermisosObra, verificarPermisosTipo, puedeEditar } = usePermisos(usuario);

  return (
    <PermisosContext.Provider value={{ verificarPermisosObra, verificarPermisosTipo, puedeEditar }}>
      {children}
    </PermisosContext.Provider>
  );
};